export const SCA_INFO = {
  timestamp: '2025-12-11 17:30:51',
  responseName: 'SCAResponse',
  slResponseType: 'CONTENT_DATA',
  contentData: {
    id: 6,
    pmEnvironment: {
      id: 1,
      name: 'Local',
      label: 'local',
    },
    code: 'LUXURY_BARBER_BY_STORE_BOOKINGS',
    name: 'LuxuryBarber',
    isFeMaInMaintenance: false,
    scaPropertyList: [
      {
        key: 'url_privacy_policy',
        value: 'https://www.iubenda.com/privacy-policy/33512443',
        type: 'String',
      },
      {
        key: 'url_social.facebook.ios',
        value: 'fb://profile/2136808549677217',
        type: 'String',
      },
      {
        key: 'url_social.facebook.android',
        value: 'fb://page/2136808549677217',
        type: 'String',
      },
      {
        key: 'url_social.facebook.alternative_url',
        value: 'https://www.facebook.com/LuxuryBarbers/',
        type: 'String',
      },
      {
        key: 'url_social.instagram.ios',
        value: 'instagram://user?username=luxury__barber',
        type: 'String',
      },
      {
        key: 'url_social.instagram.android',
        value: 'instagram://user?username=luxury__barber',
        type: 'String',
      },
      {
        key: 'url_social.instagram.alternative_url',
        value: 'https://www.instagram.com/luxury__barber/',
        type: 'String',
      },
      {
        key: 'url_store.ios',
        value: 'itms-apps://itunes.apple.com/app/1608921659',
        type: 'String',
      },
      {
        key: 'url_store.android',
        value:
          'https://play.google.com/store/apps/details?id=it.ynosit.storebookings.luxurybarber',
        type: 'String',
      },
      {
        key: 'enabled.modules.fidelity_points',
        value: 'false',
        type: 'String',
      },
      {
        key: 'maps_pin.name',
        value: 'BarberShop',
        type: 'String',
      },
      {
        key: 'maps_pin.description',
        value: 'BarberShop',
        type: 'String',
      },
      {
        key: 'url_backend',
        value: 'https://prod.ynosit.it:1999',
        type: 'String',
      },
    ],
  },
  scaCredentials: {
    refreshToken:
      'eyJhbGciOiJIUzI1NiJ9.eyJJRF9TQ0FfQUNDT1VOVCI6MSwiaWF0IjoxNzY1NDcwNjUxLCJzdWIiOiJZbm9zaXRzcmwiLCJpc3MiOiJZbm9zaXRzcmwiLCJleHAiOjE3NjU0NzgxNTF9.DOkvzCCQwruo6utvbJy50bQ-kBzG2GcfPtguXtJCqTk',
  },
  path: 'https://prod.ynosit.it:1993/sonytools-0.0.0.0/pmFrontendProperties/api/v1/findByCodeAndEnv',
};
